
import React from 'react';

export const PhotosPage = () => {
    return (
        <>
       
        </>
    )
}